import React from 'react';

interface HostsIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export const HostsIcon: React.FC<HostsIconProps> = ({ size = 20, ...props }) => {
  return (
    <svg
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      height={size}
      width={size}
    >
      <g clipRule="evenodd" fill="#B5BCC4" fillRule="evenodd">
        <path d="M4.936 4.053c-.476 0-.932.187-1.268.52a1.764 1.764 0 0 0-.525 1.254v1.67c0 .47.189.92.525 1.253.336.333.792.52 1.268.52h10.127c.475 0 .931-.187 1.268-.52.336-.332.525-.783.525-1.254v-1.67c0-.47-.189-.92-.525-1.253a1.804 1.804 0 0 0-1.268-.52H4.936ZM2.624 3.54a3.289 3.289 0 0 1 2.312-.947h10.127c.867 0 1.699.34 2.312.947.613.606.958 1.43.958 2.287v1.67c0 .857-.345 1.68-.958 2.286a3.289 3.289 0 0 1-2.312.947H4.936c-.867 0-1.699-.34-2.312-.947a3.216 3.216 0 0 1-.958-2.287v-1.67c0-.857.345-1.68.958-2.286Z" />
        <path d="M4.936 10.73c-.476 0-.932.187-1.268.52a1.764 1.764 0 0 0-.525 1.254v1.67c0 .47.189.92.525 1.253.336.333.792.52 1.268.52h10.127c.475 0 .931-.187 1.268-.52.336-.332.525-.783.525-1.254v-1.669c0-.47-.189-.921-.525-1.254a1.804 1.804 0 0 0-1.268-.52H4.936Zm-2.312-.513a3.289 3.289 0 0 1 2.312-.947h10.127c.867 0 1.699.34 2.312.947.613.607.958 1.43.958 2.287v1.67c0 .857-.345 1.68-.958 2.286a3.289 3.289 0 0 1-2.312.947H4.936c-.867 0-1.699-.34-2.312-.947a3.216 3.216 0 0 1-.958-2.287v-1.669c0-.858.345-1.68.958-2.287ZM5.78 5.931c.408 0 .738.327.738.73v.009c0 .403-.33.73-.738.73a.734.734 0 0 1-.738-.73v-.008c0-.404.33-.73.738-.73Z" />
        <path d="M5.78 12.608c.408 0 .738.327.738.73v.009c0 .403-.33.73-.738.73a.734.734 0 0 1-.738-.73v-.008c0-.404.33-.73.738-.73Z" />
      </g>
    </svg>
  );
};
